import { useLanguage } from '../context/LanguageContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

export default function FAQSection() {
  const { t } = useLanguage();

  const faqs = [
    { question: t('faq_q1'), answer: t('faq_a1') },
    { question: t('faq_q2'), answer: t('faq_a2') },
    { question: t('faq_q3'), answer: t('faq_a3') },
    { question: t('faq_q4'), answer: t('faq_a4') },
    { question: t('faq_q5'), answer: t('faq_a5') },
    { question: t('faq_q6'), answer: t('faq_a6') },
    { question: t('faq_q7'), answer: t('faq_a7') },
  ];

  return (
    <section id="faq" className="section-padding bg-brand-cream">
      <div className="section-container">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="sticker-badge mb-4">{t('faq_badge')}</span>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-brand-brown mt-4 mb-4">
              {t('faq_title')}
            </h2>
            <p className="text-brand-muted text-lg">
              {t('faq_subtitle')}
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-white rounded-2xl border border-brand-border/50 px-6 overflow-hidden"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left font-heading text-lg font-semibold text-brand-brown hover:text-brand-orange py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-brand-muted pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
